import React, {Component} from 'react';
import './Home_Page_Card_2.scss';
import Card from "@material-ui/core/Card";
import {insertHtml} from "../../../../utils/dom";

class HomePageCard2 extends Component {
    render() {
        let squareBackground = Object.assign({
            backgroundColor: "black",
            backgroundImage:
                'linear-gradient(rgba(0, 0, 0, ' + 0.2 + '),rgba(0, 0, 0, ' + (0.2 + 0.3) + ')), url(' + this.props.content.image + ')'
        }, this.props.style);

        return (
            <div id="home-page-card-2">
                <Card className="home-square not-selectable h-entry" style={squareBackground}
                     square={true} onClick={this.props.onSquareSelected}>
                    <div className="home-square-title editor-html p-name" {...insertHtml(this.props.content.title)} />
                    <div className="home-square-subtitle editor-html p-name" {...insertHtml(this.props.content.subtitle)} />
                </Card>
            </div>
        )

    }
}

export default HomePageCard2;
